import { setCommon, setUserInfo } from '@/common';
import { setLanguage } from '@/i18n';
import { useChatStore } from '@/store';
import { initGoogleAnalytics } from '@/utils/ga';
import type { InboundInit } from '@/types/bridge';

function readExtraSession(value: unknown): InboundInit['payload']['extraSession'] {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return undefined;
  return value as InboundInit['payload']['extraSession'];
}

/** 将宿主 init payload 写入全局上下文（iframe / widget / npm 共用） */
export function applyInitPayload(payload: InboundInit['payload']): void {
  setCommon('token', payload?.token || '');
  setCommon('storeId', payload?.storeId || '');
  setCommon('orgId', payload?.orgId || '');
  setCommon('tenantCode', payload?.tenantCode || '');
  setCommon('extraSession', readExtraSession(payload?.extraSession));
  const lang = payload?.language || 'en-US';
  setCommon('language', lang);
  setLanguage(lang);
  setUserInfo(payload?.email || '', payload?.uid || '', payload?.phone || '');
  setCommon('bizType', payload?.bizType);
  setCommon('solution_code', payload?.solution_code);
  setCommon('source', payload?.source || '');
  // 以下三项本工程不消费，仅透传给门店AI营销页面
  setCommon('timezone', payload?.timezone || '');
  setCommon('currency', payload?.currency || '');
  setCommon('roles', payload?.roles || '');
  initGoogleAnalytics();
  useChatStore.getState().syncHistoryScope();
  useChatStore.getState().setHostInitialized(true);
}
